module.exports = __webpack_public_path__ + "media/Audio17_r.ace2cbb3.wav";